import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEs = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_HANA_WIDGET_ERROR_FETCH_BUTTON_NO_SUGGESTIONS: 'Estoy trabajando en nuevas sugerencias para este dashlet. Por favor, haz clic en actualizar.',
  LABEL_HANA_WIDGET_ERROR_FETCH_BUTTON_REFRESH: 'Actualizar',
  LABEL_HANA_ERROR_FETCH_TITLE: 'Error al cargar los datos',
  LABEL_HANA_ERROR_FETCH_DESCRIPTION: 'No se pudieron cargar los datos',
  LABEL_HANA_ERROR_FETCH_BUTTON: 'Reintentar',
  HANA_WIDGET_ERROR_FETCH_TITLE: 'Error al cargar los datos',
  HANA_WIDGET_ERROR_FETCH_DESCRIPTION: 'No se pudieron cargar los datos del gráfico',
  HANA_WIDGET_ERROR_FETCH_BUTTON: 'Reintentar',
  HANA_WIDGET_INVALID_DATA_FORMAT: 'Formato de datos inválido'
});
export default localeEs;